export default __webpack_public_path__ + "static/media/goshen56.d1dc257a.JPG";